
import { Axios } from "../api/axios";
import { logger } from "../utils/logger";

export const getTables = async (storeId: number) => {
    return Axios(
      { 
        method: 'get',
        url: 'users/tables/stores/'+storeId,
      }).then(
        res => {
          // console.log(res)
          // authStore.setLanguage([...res.data]);
          return res;
        },
        error => {
          // console.log(error.request, error.response)
          return error.response
        }
      ).catch(error => logger.error(error));
  }

export const getLanguageSetting = (storeId: number) => {
    // const {authStore} = useStore();
    logger.debug(storeId)
    return Axios(
      { 
        method: 'get',
        url: 'i18n/language/stores/'+storeId,
      }).then(
        res => {
          // console.log(res)
          // authStore.setLanguage([...res.data]);
          return res;
        },
        error => {
          // console.log(error.request, error.response)
          return error.response
        }
      ).catch(error => logger.error(error));
  }

  export const logging = (logMessage: string, storeId: number, tableId: number) => {
    // const {authStore} = useStore();
    logger.debug(storeId)
    return Axios(
      { 
        method: 'post',
        url: 'logs/user-apps',
        data: {
            logMessage,
            storeId,
            tableId
        }
      })
  }


export const getDiningTimeLimit = async (storeId: number) => {
  return await Axios(
    { 
      method: 'get',
      url: `settings/ayce-time-limit/stores/${storeId}`
    });
}

export const getTableUserSettings = async (storeId: number) => {
  return await Axios(
    { 
      method: 'get',
      url: `settings/table-user/stores/${storeId}`
    });
} 


